
import { Conversation } from "@/core/entities/conversation";
import { GetConversationsParams, IConversationRepository } from "@/core/repositories/conversation";

export interface GetConversationsResponse {
  conversations: Conversation[];
  total: number;
  page: number;
  limit: number;
}

export class GetConversationsUseCase {
  constructor(private readonly conversationRepository: IConversationRepository) {}

  async execute(params: GetConversationsParams): Promise<GetConversationsResponse> {
    const result = await this.conversationRepository.getConversations(params);
    return {
      conversations: result.conversations?.items?.map(item => new Conversation(item)) ?? [],
      total: result.conversations?.total ?? 0,
      page: result.conversations?.page,
      limit: result.conversations?.limit,
    };
  }
}
